function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isDeepObject } from './isDeepObject'; // eslint-disable-next-line import/prefer-default-export

export var deepAssign = function deepAssign(options) {
  return function deepAssignWithOptions(target) {
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }

    sources.forEach(function (source) {
      if (!isDeepObject(source) || !isDeepObject(target)) {
        return;
      } // Copy source's own properties into target's own properties


      function copyProperty(property) {
        var descriptor = Object.getOwnPropertyDescriptor(source, property); // default: omit non-enumerable properties

        if (descriptor.enumerable || options.nonEnum) {
          // Copy in-depth first
          if (isDeepObject(source[property]) && isDeepObject(target[property])) {
            descriptor.value = deepAssign(options)(target[property], source[property]);
          } // default: omit descriptors


          if (options.descriptors) {
            Object.defineProperty(target, property, descriptor); // shallow copy descriptor
          } else {
            target[property] = descriptor.value; // shallow copy value only
          }
        }
      } // Copy string-keyed properties


      Object.getOwnPropertyNames(source).forEach(copyProperty); // default: omit symbol-keyed properties

      if (options.symbols) {
        Object.getOwnPropertySymbols(source).forEach(copyProperty);
      } // default: omit prototype's own properties


      if (options.proto) {
        // Copy souce prototype's own properties into target prototype's own properties
        deepAssign(_objectSpread(_objectSpread({}, options), {}, {
          proto: false
        }))( // Prevent deeper copy of the prototype chain
        Object.getPrototypeOf(target), Object.getPrototypeOf(source));
      }
    });
    return target;
  };
};